export default {
  chartStatistic: [],
  statAgregate : {},
  isWorkspaceEdited: false,
};
